<template lang="pug">
section
  header.header-settings
    .tabs
      .tab.primary-text.active
        span Change Password

  div
    form(@keyup.enter="submit", @submit.prevent="submit")
      AlertBox(v-if="error", type="danger", :text="error")

      .form-field(
        :class="{ error: $v.form.oldPassword.$error, 'error-required': !$v.form.oldPassword.required }"
      )
        label
          h6 Current Password
          input(
            type="password",
            placeholder="Current Password",
            v-model="$v.form.oldPassword.$model"
          )

      .form-field(
        :class="{ error: $v.form.password.$error, 'error-required': !$v.form.password.required }"
      )
        label
          h6 New Password
          input(
            type="password",
            minlength="8",
            placeholder="New Password",
            v-model="$v.form.password.$model"
          )

      .form-field
        SubmitButton(label="Save", :formState="formState")
</template>

<script>

import { required } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
import { form } from '@/mixins/form'

export default {
  name: 'SettingsChangePassword',
  mixins: [form],
  beforeCreate () {
    /*this.$store.dispatch('user/getUser')
      .then(() => {
        this.form = Object.assign({}, this.$store.state.user)
        console.log('hiya', this.form)
      })*/

  },
  data () {
    return {
      formState: 'initial',
      form: {
        password: '',
        oldPassword: ''
      },
      error: null
    }
  },
  validations: {
    form: {
      password: {
        required
      },
      oldPassword: {
        required
      }
    }
  },
  computed: {
  },
  methods: {
    submit () {
      if (this.__formInvalid()) return

      this.formState = 'pending'

      this.$store.dispatch('user/updatePassword', this.form)
        .then(() => {
          //this.$toast.open('Password Saved');
          this.formState = 'success'
          this.form = {
            password: '',
            oldPassword: ''
          }

          this.$v.$reset()
          this.error = null
        }, error => {
          this.formState = 'initial'
          this.error = error
          console.log(error)
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>
